<template>
  <div class="layout-page-index">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'PageIndex'
}
</script>

<style lang="scss">
  .layout-page-index {
    height: 100%;
  }
</style>
